var publicPath = __webpack_public_path__;
            var symbolUrl = 'img/sprite.3d7967c1.svg#icon-social-instagram';
            var viewUrl = 'img/sprite.3d7967c1.svg#view-icon-social-instagram';

            

            module.exports = {
                symbol: publicPath + symbolUrl,
                view: publicPath + viewUrl,
                viewBox: '0 0 24 24',
                title: 'social-instagram',
                toString: function () {
                    return JSON.stringify(this.view);
                }
            };